import { render } from "./paragraph.vue?vue&type=template&id=3c3aa8ab&scoped=true"
import script from "./paragraph.vue?vue&type=script&lang=js"
export * from "./paragraph.vue?vue&type=script&lang=js"

import "./paragraph.vue?vue&type=style&index=0&id=3c3aa8ab&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_feeder\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3aa8ab"]])

export default __exports__